import React from "react";
import './footer.css';

function Footer() {
  return (
    <div className="AppFooter">
      <div className="wrapper">
        <div className="footerText">
          <span>Հեղինակային իրավունք © 2024 «Աբաջյան Շին» ՍՊԸ Բոլոր իրավունքները պաշտպանված են:</span>
          <span>ՄՄ</span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
